import { z } from 'zod';
import { UserPartialSchema } from '../user/user';
import { DealPartialSchema } from '../deal/deal';

export const MissionSchema = z.object({
    id: z.number(),
    ressource: UserPartialSchema,
    deal: DealPartialSchema,
    produced_days: z.string().nullable(),
    non_billable_days: z.string().nullable(),
    billed_days: z.string().nullable(),
    available_m1: z.number().nullable(),
    available_m2: z.number().nullable(),
    available_m3: z.number().nullable(),
    available_q1: z.number().nullable(),
    available_s1: z.number().nullable(),
    status: z.literal(0).or(z.literal(1)).or(z.literal(2)),
    billable_days: z.string().nullable(),
    daily_rate: z.string(),
    notes: z.string().nullable(),
    projection_m1: z.string().nullable(),
    projection_m2: z.string().nullable(),
    projection_m3: z.string().nullable(),
    projection_q1: z.string().nullable(),
    projection_s1: z.string().nullable(),
    produced_days_m1: z.string().nullable(),
});

export type Mission = z.infer<typeof MissionSchema>;

export const MissionPartialSchema = MissionSchema.partial();
export type MissionPartial = z.infer<typeof MissionPartialSchema>;

export function newMission(data: unknown) {
    if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }

    if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }

    return {
        ...MissionSchema.parse({...data})
    };
}

export function parseMission(data: any, partial = false) {
    if (!partial) {
        return {
            ...MissionSchema.parse(data)
        };
    }
    else if (data === null || data === undefined) {
        throw new Error('Payload can\'t be null or undefined.');
    }
    else if (typeof data !== 'object') {
        throw new Error('Payload has to be an object');
    }
    else if (Object.keys(data).length === 0) {
        throw new Error('Payload Object can\'t be null');
    }
    else {
        return {
            ...MissionSchema.parse(data)
        };
    }
}